export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "purchase_date_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date à laquelle le contrat a été souscrit et payé."])},
        "contract_start_date_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date à laquelle la couverture du contrat prend effet."])}
      },
      "en": {
        "purchase_date_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date on which the contract was taken out and paid for."])},
        "contract_start_date_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date on which coverage under the contract takes effect."])}
      }
    }
  })
}
